import React from 'react';
import { FaEllipsisH } from 'react-icons/fa';

import {
  Box,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useThemedValueSwitch,
} from '@tq/ui-components';

import { ConsultationDocument } from 'api';
import { MenuOption } from 'types';
import { useTranslation } from 'react-i18next';

export interface ActionMenuButtonEllipsisProps {
  options: MenuOption[];
  consultationId?: number;
  document?: ConsultationDocument;
  ariaLabel?: string;
}
export const ActionMenuButtonEllipsis: React.FC<ActionMenuButtonEllipsisProps> = ({
  options,
  consultationId,
  document,
  ariaLabel,
}) => {
  const { t } = useTranslation('action');
  const { tvs } = useThemedValueSwitch();

  return (
    <Box width={8} height={8}>
      <Menu>
        <MenuButton
          aria-label={ariaLabel ?? t('action-button-aria-label', 'Actions button')}
          variant='menu'
          as={IconButton}
          icon={<FaEllipsisH />}
          height='100%'
          fontSize={tvs({ tq: '1.25rem' })}
          onClick={(event) => event.stopPropagation()}
        />
        <MenuList mt={0} position='absolute' right='-32px'>
          {options.map((option) => (
            <MenuItem
              key={option.label}
              whiteSpace='nowrap'
              onClick={(event) => {
                event.stopPropagation();
                option.onClick?.(consultationId, document);
              }}
            >
              <Icon mr={2} as={option.icon} />
              {option.label}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
};
